import { render, staticRenderFns } from "./ModalCertificate.vue?vue&type=template&id=d17b3f50&scoped=true&"
import script from "./ModalCertificate.vue?vue&type=script&lang=js&"
export * from "./ModalCertificate.vue?vue&type=script&lang=js&"
import style0 from "./ModalCertificate.vue?vue&type=style&index=0&id=d17b3f50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d17b3f50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
